import { Link } from '@inertiajs/react'
import { cn } from '@/lib/utils'

interface Props {
  num: number
  icon: string
  title: string
  description: string
  href: string
  done: boolean
  disabled: boolean
}

export function ProcessStepCard ({ num, icon, title, description, href, done, disabled }: Props): React.ReactElement {
  return (
    <Link
      href={href}
      className={cn(
        'bg-(--bp-surface) border rounded-[10px] p-5 cursor-pointer transition-all relative no-underline block hover:border-(--bp-accent) hover:shadow-[0_0_0_3px_var(--bp-accent-pale)]',
        done
          ? 'border-(--bp-ok-border) bg-(--bp-ok-pale)'
          : 'border-(--bp-border)'
      )}
      style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
    >
      <div
        className={cn(
          'text-[10px] font-bold tracking-[0.06em] uppercase mb-[10px]',
          done ? 'text-(--bp-ok)' : 'text-(--bp-ink3)'
        )}
      >
        Step {num}
      </div>
      <div className='text-[24px] mb-[10px]'>{icon}</div>
      <div className='text-sm font-semibold text-(--bp-ink) mb-1'>{title}</div>
      <div className='text-xs text-(--bp-ink3) leading-[1.5]'>{description}</div>
      {done && (
        <div className='absolute top-3 right-3 w-[18px] h-[18px] rounded-full bg-(--bp-ok) text-white flex items-center justify-center text-[10px] font-bold'>
          ✓
        </div>
      )}
    </Link>
  )
}
